module.exports = __webpack_public_path__ + "static/media/DB-1538_58x58x58_widthsMaxList_FLAGGED.b91d4983.bin";